import React from 'react';

import MIcon from 'views/MIcon/MIcon';

import classes from './MSelectDropdownIndicator.module.scss';

type Props = Record<never, never>;

const MSelectDropdownIndicatorView: React.FC<Props> = () => {
  return <MIcon className={classes['container']} name="opositeChevrons" size="s"></MIcon>;
};

MSelectDropdownIndicatorView.displayName = 'MSelectDropdownIndicatorView';
MSelectDropdownIndicatorView.defaultProps = {};

export default MSelectDropdownIndicatorView;
